import logoIMG from './logo.svg';

export const Logo = () => (
  <img src={logoIMG} width="64px" height="32px" alt="Ignite logo" />
);
